var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "before-after" },
    [_vm._t("default"), _c("Icon", { attrs: { name: "cart", size: "25px" } })],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }